/**
 * Dev Command Group
 * Developer tools for local development environments
 * jai1 dev (alias: d)
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createMailCommand } from './mail/index.js';

function showDevHelp(): void {
    console.log(chalk.bold.cyan('🧪 j dev') + chalk.dim(' - Dev tools cho môi trường local'));
    console.log();
    console.log(chalk.bold('Tools:'));
    console.log(`  ${chalk.cyan('mail')}    Quản lý temp email accounts (via mail.tm)`);
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ j dev mail create'));
    console.log(chalk.dim('  $ j dev mail list'));
    console.log(chalk.dim('  $ j dev mail watch <address>'));
    console.log();
    console.log(chalk.dim('Chạy "j dev <tool> --help" để xem chi tiết'));
}

export function createDevCommand(): Command {
    const cmd = new Command('dev')
        .alias('d')
        .description('Developer tools for local development environments')
        .action(() => {
            showDevHelp();
        });

    cmd.addCommand(createMailCommand());

    return cmd;
}
